import { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
//import axios from 'axios';

import { 
  Box,
  Typography,
} from "@mui/material";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

import { ConfirmDialogSingle } from "../common/HelperFunc"

import { FONT_PROPS } from "../../styles/colors";
import { COLORS } from "../../styles/colors";

/////////////////////////
// 이미지 업로드 컴포넌트
/////////////////////////
export const ImageUploader = forwardRef((props, ref) => {
  const { customSX } = props; // 커스텀 스타일 속성
  const inputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);

  // 클릭해서 파일 선택
  const handleClick = () => {
    inputRef.current.click();
  };

  // 파일 변경 시
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileSelect(file);
    } 
    // 반드시 input 값을 초기화해서 같은 파일을 다시 선택해도 change 이벤트가 발생하도록 함
    e.target.value = '';
  };

  // 드래그 앤 드롭
  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  // 미리보기 URL 메모리 해제 (변경 or 언마운트 시)
  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  // 파일 선택 처리
  const handleFileSelect = (file) => {

    const MAX_FILE_SIZE_MB = 5; // 최대 5MB
    const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // 바이트로 변환

    const isJPEG = file.type === 'image/jpeg' || /\.jpe?g$/i.test(file.name);
    const isPNG  = file.type === 'image/png'  || /\.png$/i.test(file.name);
    if (!isJPEG && !isPNG) {
      // alert('JPEG(JPG) 또는 PNG 형식만 업로드 가능합니다.');
      openMessageAlarm(
        '안내',
        'JPEG(JPG) 또는 PNG 형식만 업로드 가능합니다.'
      );

      // 리셋
      if (inputRef && inputRef.current) inputRef.current.value = '';

      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      // alert(`파일 크기는 ${MAX_FILE_SIZE_MB}MB를 초과할 수 없습니다.`);
      openMessageAlarm(
        '안내',
        `파일 크기는 ${MAX_FILE_SIZE_MB}MB를 초과할 수 없습니다.`
      );

      // 리셋
      if (inputRef && inputRef.current) inputRef.current.value = '';

      return;
    }

    setSelectedFile(file); // 선택된 파일 저장
    setPreviewUrl(URL.createObjectURL(file)); // 미리보기 URL 생성
  };

  // 메시지 박스의 알람 메시지
  const [messageAlarm, setMessageAlarm] = useState({
      isOpen: false,
      title: '',
      message: '',
  });
  const openMessageAlarm = (title='', message='',) => {
    setMessageAlarm({
      ...messageAlarm,
      isOpen: true,
      title: title,
      message: message,
    });
  };
  const closeMessageAlarm = () => {
    setMessageAlarm({
      ...messageAlarm,
      isOpen: false,
      title: '',
      message: '',
    });
  };

  // // 백엔드 업로드
  // const handleUpload = async () => {
  //   if (!selectedFile) return alert('파일을 먼저 선택하세요.');

  //   const formData = new FormData();
  //   formData.append('image', selectedFile);

  //   try {
  //     const res = await axios.post('http://localhost:5000/upload', formData);
  //     alert('업로드 완료!');
  //     console.log(res.data);
  //   } catch (err) {
  //     console.error(err);
  //     alert('업로드 실패');
  //   }
  // };

  // 부모에서 접근할 수 있게 노출할 함수들
  useImperativeHandle(ref, () => ({
    // 이미지 파일 반환
    getImage: () => {
      if(!selectedFile) {
        //alert('파일을 먼저 선택하세요.');
        return null;
      }
      // 이미지 파일, 미리보기 URL 반환
      return {imageFile: selectedFile, previewUrl: previewUrl};
    },
    // 미리보기 URL 메모리 강제 해제 (혹시 몰라서 만들었습니다. 아직은 사용 안함)
    // getRevokePreviewUrl: () => {
    //   if(previewUrl) {
    //     URL.revokeObjectURL(previewUrl);
    //   }
    // }
  }));

  // 렌더링
  return (
    <div>
      {/* 숨겨진 input */}
      <input
        type="file"
        accept="image/jpeg,image/png,.jpg,.jpeg,.png" // PNG, JPEG 형식 허용
        // accept="*/*,.jpeg,.jpg" // JPEG 형식만 허용
        //accept="image/*" // 모든 이미지 형식 허용
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />

      {/* 커스텀 업로드 박스 */}
      <Box
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            width: '25vw',
            height: '25vh',
            borderRadius: 2,
            border: `2px dashed ${COLORS.BORDER_DASH}`,
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: COLORS.HOVER_BACKGROUND,
                borderColor: FONT_PROPS.ACTIVE_COLOR,
            },
            backgroundColor: dragOver ? COLORS.HOVER_BACKGROUND : COLORS.BACKGROUND_BRIGHTER, // 드래그 오버 시 배경색 변경
            ...customSX, // customSX가 있으면 덮어씌움
        }}
      >
        {/* 이미지가 없을 경우 기본 아이콘과 텍스트 표시, 있으면 이미지 미리보기 */}
        {previewUrl ? (
          <img
            src={previewUrl}
            alt="Preview"
            style={{
              width: '100%',
              height: '100%',
              //objectFit: 'cover', // 비율 유지하며 채움
              //borderRadius: 'inherit', // Box의 borderRadius 따라감
            }}
          />
        ) : (
          <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
          }}
          >
            <AddPhotoAlternateIcon fontSize="large" sx={{ color: COLORS.PRIMARY, margin:'12px'}} />
            <Typography sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.SEMIBOLD,
              fontSize: '15px',
              color: FONT_PROPS.GRAY,
            }}>
              클릭 혹은 드래그하여 이미지를 업로드하세요.
            </Typography>
            <Typography sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              fontSize: '13px',
              color: FONT_PROPS.GRAY,
            }}>
              1개씩, 최대 5MB까지 업로드 가능합니다.
            </Typography>
            <Typography sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              fontSize: '13px',
              color: FONT_PROPS.GRAY,
            }}>
              (이미지 확장자는 .jpg, .jpeg, .png만 지원합니다.)
            </Typography>
            {/* <Typography sx={{
              fontFamily: FONT_PROPS.PRIMARY,
              fontWeight: FONT_PROPS.MEDIUM,
              fontSize: '13px',
              color: FONT_PROPS.GRAY,
            }}>
              이미지 크기는 600x600px 이하.
            </Typography> */}
          </Box>
        )}
      </Box>

      {/* 경고 메시지 박스 알람 */}
      <ConfirmDialogSingle  
        open={messageAlarm.isOpen}
        title={messageAlarm.title}
        message={messageAlarm.message}
        onCancel={closeMessageAlarm}
      />
    </div>
  );
});